var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-link',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"deployment-instance d-flex justify-content-center align-items-center",class:_vm.cssClass,attrs:{"title":_vm.tooltipText}})}
var staticRenderFns = []

export { render, staticRenderFns }